import { z } from "zod";

export const EntregaObraCadastroSchema = z.object({
    idEntregaObra: z.number().int().optional(),
    idCentroCusto: z.number().int().positive(),
    status: z.coerce.number().default(0),
});

export type EntregaObraCadastroForm = z.infer<typeof EntregaObraCadastroSchema>;

export const defaultEntregaObraCadastroForm: Partial<EntregaObraCadastroForm> = {
    idEntregaObra: undefined,
    idCentroCusto: undefined,
    status: 0,

};
